import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconChatReview = deprecatedComponent({
    displayName: 'IconChatReview',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M11.3065 27.0657L11.5148 26.3452C11.3337 26.2929 11.1397 26.3106 10.9711 26.3949L11.3065 27.0657ZM3.97852 30.7297L3.23605 30.6236C3.1966 30.8998 3.31368 31.175 3.53998 31.3381C3.76629 31.5013 4.06442 31.5253 4.31393 31.4005L3.97852 30.7297ZM5.0087 23.5184L5.75117 23.6245C5.78565 23.3831 5.70065 23.14 5.52327 22.9728L5.0087 23.5184ZM16 28.4733C24.6223 28.4733 31.7803 22.303 31.7803 14.4967H30.2803C30.2803 21.3001 23.9798 26.9733 16 26.9733V28.4733ZM11.0983 27.7862C12.6427 28.2325 14.2905 28.4733 16 28.4733V26.9733C14.4316 26.9733 12.9239 26.7524 11.5148 26.3452L11.0983 27.7862ZM4.31393 31.4005L11.6419 27.7365L10.9711 26.3949L3.64311 30.0589L4.31393 31.4005ZM4.26624 23.4123L3.23605 30.6236L4.72098 30.8358L5.75117 23.6245L4.26624 23.4123ZM0.219727 14.4967C0.219727 18.2128 1.85551 21.5757 4.49414 24.064L5.52327 22.9728C3.15057 20.7352 1.71973 17.7545 1.71973 14.4967H0.219727ZM16 0.52002C7.37777 0.52002 0.219727 6.69037 0.219727 14.4967H1.71973C1.71973 7.69323 8.02028 2.02002 16 2.02002V0.52002ZM31.7803 14.4967C31.7803 6.69037 24.6223 0.52002 16 0.52002V2.02002C23.9798 2.02002 30.2803 7.69323 30.2803 14.4967H31.7803Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M11.8223 16.3274L15.0829 19.3619L22.1095 11.5596",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconChatReview };
